import { Authority } from 'platform/app/authority.constant';

export const AD_BOARD = {
    name: 'AdBoard',
    path: '/ad-board',
    icon: 'dm-image',
    requiresAuthority: Authority.ROLE_AD_BOARD_VIEW_EDIT,
};
